// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5071":"6d5d5e96","7170":"c96c5534","7496":"6d5d5e96","7983":"ca4ff35f","9628":"5c0f1342","9909":"6d5d5e96"}[chunkId] + ".chunk.css";
};